export default __webpack_public_path__ + "static/media/background-vid-small.dff819b0.svg";